var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPublicationFileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 34,
    viewBox: "0 0 27 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.592.637H5.338a3.517 3.517 0 00-3.512 3.512v12.988h-.343c-.782 0-1.416.633-1.416 1.415v8.583c0 .782.634 1.415 1.416 1.415h.343v1.574a3.516 3.516 0 003.512 3.513h18.085a3.516 3.516 0 003.51-3.513V8.95L18.594.637zm4.83 30.849H5.339c-.75 0-1.36-.61-1.36-1.362v-1.573h16.858c.782 0 1.416-.634 1.416-1.416v-8.583c0-.782-.634-1.415-1.416-1.415H3.978V4.149c0-.749.61-1.36 1.36-1.36l12.45-.012v4.602a2.437 2.437 0 002.435 2.435l4.508-.013.05 20.323c0 .751-.609 1.362-1.358 1.362z",
    fill: "url(#publicationFileIcon_svg__paint0_linear_1470_11922)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "publicationFileIcon_svg__paint0_linear_1470_11922",
    x1: 26.934,
    y1: 33.637,
    x2: 0.067,
    y2: 33.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2091EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#1A9DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#0DBCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01D6B9"
  })))));
}

export default SvgPublicationFileIcon;